// import slick from 'slick-carousel';

export default (el) => {
	$('.books').slick({
		arrows: true,
		prevArrow: $('.prev-arrow'),
		nextArrow: $('.next-arrow'),
		infinite: true,
		speed: 600,
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		dots: true,
		appendDots: '.dots',
		responsive: [
			{
				breakpoint: 599,
				settings: {
					slidesToShow: 3
				}
			}
		]
	});
};
